export class Button {
   constructor(button) {
       this.button = button;
       this.form = button.form;
       this.eventFired = false;
       this.prefentDubbleClick();
   }

   /**
    * EVERY "htmlInputElement" MUST HAVE AN ID!
    * Adds a fake radio button (label) for htmlInputElement
    * @param {HTMLElement} htmlInputElement
    */
    prefentDubbleClick() {
        this.button.addEventListener('click', event => {
            event.preventDefault();
            this.button.setAttribute("disalbed", "disalbed");
            this.button.classList.add("button--disabled");
            if(!this.eventFired) {
                this.eventFired = true;
                this.form.submit();
            } else {
                console.log("clicked");
            }
        });
    }
}

let buttons = document.querySelectorAll('button[type="submit"]');
[...buttons].forEach((button) => new Button(button));




// WEBPACK FOOTER //
// ./src/my_artis/js/components/button.js